<template>
  <div class="roadtrip">
    <template v-if="desktop">
      <link rel="preload" as="image" href="/Static/images/roadtrip/loading_desktop.gif" />
    </template>
    <template v-else>
      <link rel="preload" as="image" href="/Static/images/roadtrip/loading_mobile.gif" />
    </template>

    <div class="roadtrip__start-page" v-if="step === 'startPage'">
      <div class="container">
        <div class="roadtrip__inner">
          <h1 class="visually-hidden">Welcome to the Asda adventure planner</h1>
          <img src="/Static/images/roadtrip/logo.gif" alt="Adventure Planner" class="roadtrip__logo" />

          <p>
            Jump start your getaway plans with the Asda Money Adventure Planner! Discover exciting activities and
            adventures all over the UK - all you have to do is take our quiz to answer a few simple questions and Asda
            Money will create your very own personalised adventure.
          </p>

          <p>So, what are you waiting for? It's time to hit the road again with Asda Money!</p>

          <button type="button" @click="begin" class="btn">Start my trip</button>
        </div>
      </div>
      <img src="/Static/images/roadtrip/car_driving.gif" alt="" class="roadtrip__start-car" />
    </div>

    <div class="container">
      <div v-if="step === 'questions'">
        <Questions></Questions>
      </div>
    </div>

    <div class="roadtrip__recommendations" v-if="step === 'results'">
      <Recommendation :insuranceUrls="insuranceUrls"></Recommendation>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Questions from './Questions.vue';
import Recommendation from './Recommendation.vue';

export default {
  name: 'Roadtrip',
  data: () => ({
    desktop: false,
  }),

  components: {
    Questions,
    Recommendation,
  },

  props: {
    countries: {
      type: Array,
      default: null,
    },
    insuranceUrls: {
      type: Array,
      default: null,
    },
  },

  computed: {
    ...mapState('roadtrip', ['step']),
    ...mapGetters('roadtrip', ['selectedAnswers']),
  },

  created() {
    for (let index = 0; index < this.countries.length; index++) {
      const element = this.countries[index];
      this.$store.commit('roadtrip/addLinks', element);
    }

    if (window.innerWidth > 768) {
      this.desktop = true;
    }
  },

  methods: {
    begin() {
      this.$store.commit('roadtrip/setStep', 'questions');
    },
  },
};
</script>

<style lang="scss">
.roadtrip {
  max-width: 100vw;
  overflow: hidden;
  min-height: calc(100vh - 56px);

  h1 {
    color: $green;
    margin-bottom: 0.5rem;
    font-size: 2.4rem;
    line-height: 3.2rem;

    @include breakpoint(lg) {
      font-size: 4.8rem;
      margin-bottom: 2.5rem;
      line-height: 4rem;
    }
  }

  .roadtrip__subtitle {
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 2.8rem;

    @include breakpoint(lg) {
      font-size: 2rem;
      line-height: 4rem;
    }
  }

  .main {
    text-align: center;
  }

  [type='radio'] + label {
    cursor: pointer;
  }

  .btn {
    border: 4px solid $green;
    background-color: $green;
    padding: 1.2rem 4.4rem;
    min-width: 20rem;
    line-height: 2.2rem;

    @include breakpoint(lg) {
      min-width: 25rem;
    }

    &:hover,
    &:focus {
      background-color: $black;
      border-color: $black;
    }
  }

  .btn--black-border {
    border: 4px solid $black;
    background-color: $white;
    color: $black;

    &:hover,
    &:focus {
      color: $white;
    }
  }

  /* HTML5 Boilerplate accessible hidden styles */
  [type='radio'] {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .slick-track {
    display: flex;
  }

  .slick-slide {
    opacity: 0.5;
    transition: opacity 0.2s ease;
    height: auto;
    float: none;

    > div {
      display: flex;
      height: 100%;
    }

    &.slick-active {
      opacity: 1;
    }
  }

  .slick-list {
    overflow: visible;
  }

  .slick-dots {
    position: static;
    margin: 2.4rem 0;
  }

  .slick-dots li {
    width: 3rem;
    height: 3rem;

    button {
      padding: 0;
      width: 3rem;
      height: 3rem;
      position: relative;

      &:before {
        content: '';
        background: #ccc;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .slick-dots .slick-active button:before {
    background: $green;
  }
}

.roadtrip__answers {
  margin: 0 auto;

  @include breakpoint(lg) {
    display: flex;
    width: 100%;
    // align-items: flex-start;
    justify-content: center;
    flex-flow: row wrap;
    align-content: flex-end;

    .roadtrip__answer {
      flex-grow: 1;
    }

    .roadtrip__answer:nth-last-child(n + 5),
    .roadtrip__answer:nth-last-child(n + 5) ~ .roadtrip__answer {
      flex-basis: calc(20% - 2.4rem);
      max-width: calc(20% - 2.4rem);
    }
  }
}

.roadtrip__logo {
  margin: 0 auto 2rem;
  max-width: 20rem;

  @include breakpoint(lg) {
    margin: 0 auto 3.5rem;
    max-width: 35rem;
  }
}
.btn.btn--center {
  margin: 0 auto;
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
.roadtrip {
  text-align: center;
  font-family: 'Montserrat', sans-serif;

  p {
    font-size: 1.4rem;
    line-height: 2rem;
    margin: 0 0 2rem;
    font-weight: 500;

    @include breakpoint(lg) {
      line-height: 2.8rem;
      font-size: 1.8rem;
      margin: 0 0 3rem;
    }
  }
}

.arrow-link:hover,
.arrow-link:focus {
  text-decoration: underline;
}

.roadtrip__inner {
  max-width: 70rem;
  margin: 0 auto;
}

.roadtrip__start-car {
  position: absolute;
  bottom: -2px;
  left: 0;
  max-width: 78rem;
  z-index: -1;

  @media (min-width: 480px) {
    max-width: 100rem;
  }

  @include breakpoint(sm) {
    max-width: 135rem;
  }

  @include breakpoint(lg) {
    left: 0;
    min-width: 170rem;
    transform: none;
    max-width: 100%;
  }
}

.roadtrip__start-page {
  position: relative;
  padding: 3rem 0 17rem;
  min-height: calc(100vh - 56px);

  @include breakpoint(sm) {
    padding: 3rem 0 23rem;
  }

  @include breakpoint(lg) {
    min-height: calc(100vh - 156px);
    padding: 3rem 0 34rem;
  }
}
</style>
